
class Branch {
    constructor(branch = {name, location: { address: "", floor: null, apartment: null, latitude: null, longitude: null, country: null, province: null, locality: null }, isDefault: false }) {
        this.className = 'Branch'
        this.name = branch.name;
        this.location = {
            localityFilter: branch.location.localityFilter,
            address: branch.location.address,
            floor: branch.location.floor,
            apartment: branch.location.apartment,
            latitude: branch.location.latitude,
            longitude: branch.location.longitude,
            country: branch.location.country,
            province: branch.location.province,
            locality: branch.location.locality,
            postalCode: branch.location.postalCode
        }
        this.isDefault = branch.isDefault
    }
}

export default Branch;
